import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { hiddenDots } from 'src/components/pages/Case/helpers/hiddenDots';
import { useTheme } from 'styled-components';
import { LinkCount, LinksContainer } from './CaseLinksTableCell.styles';

interface Props {
  linksCount?: number | null;
  canViewCaseDetails: boolean;
}

export const CaseLinksTableCell = ({
  linksCount,
  canViewCaseDetails,
}: Props) => {
  const theme = useTheme();
  if (!canViewCaseDetails) {
    return <>{hiddenDots}</>;
  }
  if (!linksCount) {
    return <></>;
  }
  return (
    <LinksContainer>
      <StyledIcon
        className="uil uil-link"
        size="16px"
        color={
          theme.isVaultVariant
            ? theme.newPalette.neutral.N800
            : theme.atlas.semantic.color.type.default
        }
      />
      <LinkCount>{linksCount}</LinkCount>
    </LinksContainer>
  );
};
